import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RegisterModel} from '@shared/models/register.model';
import {LoginService} from '@shared/services/login.service';

@Component({
  selector: 'si-register-password',
  templateUrl: './register-password.component.html',
  styleUrls: ['./register-password.component.scss']
})
export class RegisterPasswordComponent implements OnInit {
  @Input() model = new RegisterModel();
  @Input() wideResolution: boolean;
  @Input() errorText: string;
  @Output() modelChange = new EventEmitter<RegisterModel>();
  validationErrorTextPasswordConfirm: string;
  textPasswordPolicies: string;

  constructor(
    private loginService: LoginService
  ) {
  }

  ngOnInit(): void {
    this.getPasswordPolicies();
  }

  async getPasswordPolicies(): Promise<void> {
    this.textPasswordPolicies = await this.loginService.getPasswordPoliciesText();
  }

  onChangePassword(): void {
    this.validateSamePassword();
  }

  onChangePasswordConfirm(): void {
    this.validateSamePassword();
  }

  validateSamePassword(): void {
    if (this.model.passwordConfirm && this.model.passwordConfirm !== this.model.password) {
      this.validationErrorTextPasswordConfirm = 'SI_RULES_ERROR_PASSWORD_DO_NOT_MATCH';
    } else {
      this.validationErrorTextPasswordConfirm = null;
    }
  }
}
